import { Center, Icon } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { ModalCloseButton } from '@/ui/ModalClosebutton';

const isSameAppId = (a: unknown, b: unknown) => {
  if (a === null || a === undefined) return false;
  if (b === null || b === undefined) return false;
  return String(a) === String(b);
};

export const SliderButtons = ({
  onClose = () => {},
  onPrev = () => {},
  onNext = () => {},
  applications = [],
  application = { appId: '0' },
  showNavItems = true,
}) => {
  const isAtLast = isSameAppId(
    applications?.[applications?.length - 1]?.appId,
    application?.appId
  );
  const isAtFirst = isSameAppId(applications?.[0]?.appId, application?.appId);

  return (
    <>
      <ModalCloseButton onClose={onClose} />
      {showNavItems && (
        <>
          {' '}
          <Center
            w="48px"
            h="48px"
            left="-60px"
            top="86px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={isAtLast ? 'not-allowed' : 'pointer'}
            onClick={onNext}
            opacity={isAtLast ? 0.5 : 1}
            data-test-id="next-candidate-job-application-details-icon"
          >
            <Icon as={ChevronRightIcon} w="24px" h="24px" />
          </Center>
          <Center
            w="48px"
            h="48px"
            left="-60px"
            top="140px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={isAtFirst ? 'not-allowed' : 'pointer'}
            onClick={onPrev}
            opacity={isAtFirst ? 0.5 : 1}
            data-test-id="previous-candidate-job-application-details-icon"
          >
            <Icon as={ChevronLeftIcon} w="24px" h="24px" />
          </Center>
        </>
      )}
    </>
  );
};
